import { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import { Tooltip } from 'antd'
import {
    EyeInvisibleOutlined,
    EyeOutlined,
    LoadingOutlined,
} from '@ant-design/icons'

import Box from '~/core/Box'
import { getUserIdentity } from '~/redux-modules/identity'

import { isVisibleToCustomer } from './logic'
import style from './styles.css'

type CustomerVisibilityPropsType = {
    id: string
    visibleToCustomer: boolean | null
    onSetVisibleToCustomer?: (id: string, visibleTocustomer: boolean) => void
    typeOfModule?: string
}

export const CustomerVisibility: FC<CustomerVisibilityPropsType> = ({
    visibleToCustomer,
    onSetVisibleToCustomer,
    id,
    typeOfModule,
}) => {
    const [loading, setLoading] = useState(false)

    const state = useSelector(stateObj => stateObj)
    const identity = getUserIdentity(state)

    const isVisibilityOn = isVisibleToCustomer(visibleToCustomer)
    const getIcon = (onClick?: () => void) => {
        const iconProps = {
            style: {
                fontSize: '22px',
            },
            spin: loading,
            onClick: onClick,
        }

        if (loading) {
            return <LoadingOutlined {...iconProps} />
        } else if (visibleToCustomer) {
            return <EyeOutlined {...iconProps} />
        }
        return <EyeInvisibleOutlined {...iconProps} />
    }

    return (
        <Tooltip
            title={isVisibilityOn ? 'Hide from customer' : 'Show to customer'}
        >
            <Box
                className={`${
                    isVisibilityOn
                        ? style.visibilityOnStyle
                        : style.visibilityOffStyle
                } ${style.visibleToCustomerStyle}`}
            >
                {typeOfModule === 'carDetails' &&
                !identity.isSupplierQualityEngineer
                    ? getIcon()
                    : getIcon(() => {
                          if (onSetVisibleToCustomer) {
                              setLoading(true)
                              onSetVisibleToCustomer(id, !visibleToCustomer)
                              setTimeout(() => {
                                  setLoading(false)
                              }, 1800)
                          }
                      })}
            </Box>
        </Tooltip>
    )
}
